import { useMemo } from 'react'

import { useExpaContext } from '../../expa'
import {
  type StoryblokCrossSellGridType,
  type StoryblokCrossSellSliderType,
} from '../storyblok'

const getExpaWidgetId = (
  expaWidgetIds: string,
  expa: string,
): string | undefined => {
  for (const row of expaWidgetIds.split('\n')) {
    const [key, value] = row.split('=')

    if (key === expa && value) {
      return value.trim()
    }
  }

  return undefined
}

/**
 * Returns best fit widget ID for Cross-Sell widget in Storyblok
 */
export const useStoryblokCrossSellWidgetId = (
  blok: StoryblokCrossSellGridType | StoryblokCrossSellSliderType,
): number | undefined => {
  const expa = useExpaContext()

  const {
    /**
     * New line separated pairs of values "expa=widget_id".
     * Example:
     * gglp=544
     * ide=317
     */
    expaWidgetIds,

    /**
     * Main widget ID field
     */
    widgetId,
  } = blok

  return useMemo(() => {
    if (expa && typeof expaWidgetIds === 'string') {
      const expaWidgetId = Number(getExpaWidgetId(expaWidgetIds, expa))

      if (expaWidgetId && !Number.isNaN(expaWidgetId)) {
        return expaWidgetId
      }
    }

    const numericWidgetId = Number(widgetId)

    return Number.isNaN(numericWidgetId) ? undefined : numericWidgetId
  }, [expa, expaWidgetIds, widgetId])
}
